import t from 'tcomb';
import escapeHTML from 'lodash/string/escape';

// converte un tag in html
// - i p sono convertiti semplicemente in testo con gli a capo
// sostituiti da <br/>
// - le liste con le liste corrispondenti ol, ul a seconda che
// siano ordinate o no
function renderTag(tag) {
  const { name, args } = tag;
  if (name === 'p') {
    return args.join('<br/>');
  }
  const lis = args.map(function(x) {
    return `<li>${x.replace(lists[name], '')}</li>`;  // toglie "- " o "+ "
  }).join('');
  return `<${name}>${lis}</${name}>`;
}

// elenco trasformazioni inline
const inline = {
  strong: function (src) {
    return src.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, "<strong>$2</strong>");
  },
  em: function (src) {
    return src.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>");
  },
  link: function (src) {
    return src.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?(.*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, function(wholeMatch, m1, text, m3, url) {
      const isMailto = url.indexOf('mailto:') === 0;
      const self = url.indexOf('self:') === 0;
      const isJS = url.indexOf('javascript:') === 0; // eslint-disable-line no-script-url
      let target;
      if ( self )  {
        target = '_self';
        url = url.substring(5, url.length);
      }
      else if ( isJS )  {
        target = '#';
      }
      else if (!isMailto) {
        target = '_blank';
      }
      let targetAttr = '';
      if (!t.Nil.is(target)) {
        targetAttr = ' target="' + target + '"';
      }
      // non uso attr() altrimenti farei due volte l'escape_html()
      return '<a href="' + url + '"' + targetAttr + '>' + text + '</a>';
    });
  }
};

const lists = {
  ul: /^- /,
  ol: /^\+ /
};

// data una linea quel'è il tag più appropriato per
// farne il rendering
function detectTag(line) {
  return lists.ul.exec(line) ?
    'ul' :
    lists.ol.exec(line) ?
    'ol' :
    'p';
}

const transformations = ['link', 'strong', 'em'];

export default function (md: t.String): t.String {

  // uniformo gli a capo a \n
  const uniformed = md.replace(/\r\n|\r/g, '\n');

  // elimino tag molesti
  const escaped = escapeHTML(uniformed);

  // applico le trasformazioni inline
  const inlined = transformations.reduce((ret, x) => inline[x](ret), escaped);

  // divido il sorgente ottenuto in blocchi divisi dagli a capo
  // e faccio un trim delle righe
  const lines = inlined.split('\n').map((s) => s.trim());

  // analizzo i blocchi per determinare i tag
  const tags = [];
  let oldTag;
  lines.forEach(function(line) {
    const newTag = detectTag(line);
    if (newTag !== oldTag) {
      tags.push({
        name: newTag,
        args: []
      });
    }
    tags[tags.length - 1].args.push(line);
    oldTag = newTag;
  });

  // render dei tag trovati
  return tags.map(renderTag).join('');
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/micromd.js
 **/